export const TABLE_SIZE = 10;
export const TABLE_PAGINATOR_SIZE = 10;